import AppDownloadBanner from './AppDownloadBanner';

export default AppDownloadBanner;
